// Enums
import { LOGIC_SET_STATUS } from '../enums/logicSetStatuses';

/**
 * Returns a function to assert the status of a logic set
 */
export const getLogicSetStatus = ({ logicSetDto = {}, excludeInactive, isOperable } = {}) => {
    const { active, reporterTypeDTO = {} } = logicSetDto;
    const { implemented } = reporterTypeDTO;

    if (!implemented) {
        return LOGIC_SET_STATUS.NOT_IMPLEMENTED;
    } else if (!isOperable) {
        return LOGIC_SET_STATUS.INOPERABLE;
    } else if (excludeInactive) {
        return LOGIC_SET_STATUS.IMPLEMENTED;
    } else {
        return active ? LOGIC_SET_STATUS.IMPLEMENTED : LOGIC_SET_STATUS.INACTIVE;
    }
};
